import { Divider, Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { AccordionSection } from '../AccordionSection';
import { useFormContext } from 'react-hook-form';
import { PhoneInput } from 'Components/HookFormInputs/PhoneInput';
import { TextInput } from 'Components/HookFormInputs/TextInput';
import { sanitizeNumbersLength } from 'Utils/sanitizeNumbers';
import { IUpdatePersonalDetails } from 'Interfaces/updatePersonalDetails';
import { ResetButton } from '../ResetButton';
import { useParams } from 'react-router-dom';
import { sanitizeLettersNumbersAndSpacialChars } from 'Utils/sanitizeLettersNumbersAndSpacialChars';
import { emailSanitation } from 'Regex';

export const ContactDetails = () => {
  const {
    register,
    formState: { errors, defaultValues },
    reset,
    watch,
  } = useFormContext<IUpdatePersonalDetails['contactDetails']>();

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.UpdatePersonalDetails
  ).contactDetails;

  const params = useParams();

  return (
    <AccordionSection
      defaultExpanded={params.sectionId === '1'}
      title={dictionary.title}
      subtitle={dictionary.subtitle}
    >
      <Stack
        alignSelf={'center'}
        alignItems={'center'}
        gap={'20px'}
        maxWidth={isDesktop ? '400px' : undefined}
      >
        <PhoneInput
          prefixValue={watch('phonePrefix') || defaultValues?.phonePrefix || -1}
          registerPhonePrefix={register('phonePrefix')}
          registerPhoneNumber={register('phoneNumber', {
            onChange: (e) => sanitizeNumbersLength(e, 7),
          })}
          prefixErrors={(errors as any)?.phonePrefix}
          numberErrors={(errors as any)?.phoneNumber}
          prefixLabel={dictionary.inputLabel1Prefix}
          numberLabel={dictionary.inputLabel1Number}
          shrink={(watch('phoneNumber') || '')?.length > 0}
          defaultPrefixId={defaultValues?.phonePrefix}
          height={isDesktop ? '48px' : '42px'}
        />
        <PhoneInput
          prefixValue={
            watch('extraPhonePrefix') || defaultValues?.extraPhonePrefix || -1
          }
          registerPhonePrefix={register('extraPhonePrefix')}
          registerPhoneNumber={register('extraPhoneNumber', {
            onChange: (e) => sanitizeNumbersLength(e, 7),
          })}
          prefixErrors={(errors as any)?.extraPhonePrefix}
          numberErrors={(errors as any)?.extraPhoneNumber}
          prefixLabel={dictionary.inputLabel2Prefix}
          numberLabel={dictionary.inputLabel2Number}
          shrink={(watch('extraPhoneNumber') || '')?.length > 0}
          defaultPrefixId={defaultValues?.extraPhonePrefix}
          height={isDesktop ? '48px' : '42px'}
        />
        <TextInput
          register={register('email', {
            onChange: (e) =>
              sanitizeLettersNumbersAndSpacialChars(e, 50, emailSanitation),
          })}
          errors={(errors as any)?.email}
          label={dictionary.inputLabel3}
          shrink={(watch('email') || '')?.length > 0}
        />
        <ResetButton
          onClick={() => reset(defaultValues)}
          resetCategoryAriaText={dictionary.reset}
        />
      </Stack>
    </AccordionSection>
  );
};
